import AmbientVideo from './ambient-video';
export default AmbientVideo;
export type { Props as AmbientVideoProps } from './ambient-video';
